import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export type FactoryGptMicroFrontendProps = SpecificMicroFrontendProps & {
  isWidget?: boolean;
  isAppMobile?: boolean;
};

export type CustomAgentMicroFrontendProps = SpecificMicroFrontendProps & {
  initialMessage?: string;
  agentId?: string;
  threadId?: string;
  showEmptyState?: boolean;
  fullWidth?: boolean;
  getScrollHost?: () => HTMLElement | null;
};

export const FactoryGptMicroFrontend: FC<FactoryGptMicroFrontendProps> = ({
  entryPointUrl,
  isAppMobile,
  isMobile,
  isTablet,
  isSmartTV,
  ...props
}) => {
  // Determine which exposed path to use based on device type
  const exposedPath = isAppMobile ? constants.MFE_MOBILE_EXPOSED_PATH : constants.MFE_EXPOSED_PATH;

  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_FACTORY_GPT_NAME}
      exposedPath={exposedPath}
      isAppMobile={isAppMobile}
      isMobile={isMobile}
      isTablet={isTablet}
      isSmartTV={isSmartTV}
      {...props}
    />
  );
};

export const FactoryGptWidget: FC<FactoryGptMicroFrontendProps> = ({
  entryPointUrl,
  isAppMobile,
  ...props
}) => {
  // Note: Widget always uses the same entrypoint, but we still track mobile mode for consistency

  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_FACTORY_GPT_NAME}
      exposedPath={constants.WIDGET_EXPOSED_PATH}
      isAppMobile={isAppMobile}
      {...props}
    />
  );
};

export const CustomAgentMicroFrontend: FC<CustomAgentMicroFrontendProps> = ({
  entryPointUrl,
  isAppMobile,
  ...props
}) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_FACTORY_GPT_NAME}
      exposedPath={constants.CUSTOM_AGENT_EXPOSED_PATH}
      isAppMobile={isAppMobile}
      {...props}
    />
  );
};
